import { Modelo } from '@ext/index';
import * as Types from './Categoria.types';
import * as Pedidos from '@lib/Ventas/Pedidos';
import moment, { Moment } from 'moment';
import { Categoria } from '@/__env/lib/Web/Categorias/Categoria.nav';

export class ICategoria extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Id: number;
    public Descripcion: string;
    public DescripcionNueva: string;
    public PermitePublicar: boolean = false;
    public Padre: Categoria = null;
    public Hijos: Categoria[];

    public getJson()
    {
        let js: any = {};
        js.descripcion = this.Descripcion.toLowerCase();
        if ( this.Padre )
            js.padre = this.Padre.Id;
        return js;
    }

    public set(): boolean
    {

        this.Id = this.Json.id;
        this.PermitePublicar = this.Json.permite_publicar == 'S';
        this.Descripcion = this.Json.descripcion ? this.Json.descripcion.toCapitalCase() : '';
        this.DescripcionNueva = this.Json.descripcion ?  this.Json.descripcion.toCapitalCase() : '';
        this.Padre = this.Json.padre ? new Categoria( this.Json.padre ) : null;
        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: ICategoria )
    {
        this.Model = Model;
    }

    public Model: ICategoria;
}